import React from "react";
import "./header.css";
import { useContext } from "react";
import AuthContext from "../store/auth-context";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";

function OtherHeader() {
  const c = useContext(AuthContext);
  function logoutHandler() {
    c.logout();
  }
  const goToBudget = () => {
    c.setProfile(false);
  };
  return (
    <Navbar collapseOnSelect expand="md" className="navBar" variant="dark">
      <Container className="nav">
        <Navbar.Brand href="/" className="name">
          Budget Master
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav" className="navBar">
          <Nav className="me-auto"></Nav>
          <Nav>
            <Nav.Link onClick={goToBudget}>Budget</Nav.Link>
            <Nav.Link onClick={logoutHandler}>Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default OtherHeader;
